import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Globe2, ScrollText, ChevronRight, Headphones } from "lucide-react";
import TripAutoHero from "../components/TripAutoHero";

const GUIDES = [
  {
    to: "/india/guides/visiting-india",
    tag: "Foreign travelers",
    title: "Visiting India: A Complete Guide for Foreign Travelers",
    desc: "Visa rules and e-Visa categories, e-Arrival Card, FRRO registration, Indian missions abroad, customs, safety, common scams, transportation and responsible travel.",
    icon: Globe2, tone: "text-orange-600 bg-orange-50 border-orange-200",
    testid: "india-guide-card-visiting",
  },
  {
    to: "/india/guides/oci-nri-rules",
    tag: "Indian diaspora",
    title: "OCI & NRI Rules for Travel to & Living in India",
    desc: "NRI vs OCI explained: benefits, restrictions, e-Arrival requirements, property and tax basics, passport-update rules and official Government of India links.",
    icon: ScrollText, tone: "text-emerald-700 bg-emerald-50 border-emerald-200",
    testid: "india-guide-card-oci",
  },
];

/* Travel to India — guides hub (SEO section landing page). */
export default function IndiaGuidesIndex() {
  useEffect(() => {
    document.title = "Travel to India — Guides for Visitors & the Diaspora — IndianAirports.com";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="india-guides-page">
      <div className="relative border-b border-zinc-200 overflow-hidden">
        <TripAutoHero query="India taj mahal travel gateway" alt="Travel to India" className="absolute inset-0 w-full h-full" testid="india-guides-hero" />
        <div className="absolute inset-0 bg-gradient-to-tr from-orange-900/85 via-rose-800/70 to-blue-800/60" />
        <div className="relative max-w-5xl mx-auto px-5 py-14">
          <p className="text-xs font-mono uppercase tracking-widest text-white/85">IndianAirports.com · Travel Guides</p>
          <h1 className="mt-2 font-heading font-900 text-4xl sm:text-5xl tracking-tight text-white" data-testid="india-guides-title">Travel to India</h1>
          <p className="mt-3 text-base text-white/90 max-w-2xl">
            In-depth, regularly updated guides for planning a trip to India — every guide includes section-by-section audio
            <Headphones className="inline w-4 h-4 mx-1 text-amber-300" /> and links only to official Government of India portals.
          </p>
        </div>
      </div>
      <div className="max-w-5xl mx-auto px-5 py-8 grid md:grid-cols-2 gap-5">
        {GUIDES.map(({ to, tag, title, desc, icon: Icon, tone, testid }) => (
          <Link key={to} to={to} data-testid={testid}
            className="group bg-white border border-zinc-200 rounded-2xl p-5 hover:border-blue-400 transition-colors flex flex-col">
            <span className={`self-start inline-flex items-center gap-1.5 text-[10px] font-800 uppercase tracking-wide border rounded-full px-2.5 py-1 ${tone}`}>
              <Icon className="w-3 h-3" /> {tag}
            </span>
            <h2 className="mt-3 font-heading font-800 text-lg md:text-lg group-hover:text-blue-700">{title}</h2>
            <p className="mt-1.5 text-sm text-zinc-500 leading-relaxed flex-1">{desc}</p>
            <span className="mt-3 text-xs font-800 text-blue-700 inline-flex items-center gap-1">Read the guide <ChevronRight className="w-3.5 h-3.5" /></span>
          </Link>
        ))}
      </div>
    </div>
  );
}
